import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiClient } from "../../api/api";

/**
 * @type {{
 *  isAuth: boolean,
 *  user: {
 *    birthday: number
 *    email: string
 *    gender: string
 *    username: string
 *  },
 *  error: boolean,
 *  errorMessage: string,
 *  registerSuccess: boolean,
 *  loadingRegister: boolean,
 *  loginError: string,
 *  forgotLoading: boolean,
 *  forgotError: string,
 *  forgotSuccess: boolean,
 *  loadingApp: boolean,
 * }}
 */
const initialState = {
  isAuth: false,
  user: {},
  error: false,
  errorMessage: "",
  loginError: "",
  loadingApp: false,
};

export const loginApi = createAsyncThunk(
  "auth/loginApi",
  async ({ code, email }, authApi) => {
    const response = await apiClient
      .post("auth/signin", { code, email })
      .then((res) => res.data);
    const { access_token, refresh_token } = response.data;
    localStorage.setItem("accessToken", access_token);
    localStorage.setItem("refreshToken", refresh_token);
    authApi.dispatch(getUserData());
    return response;
  },
);

export const sendCodeApi = createAsyncThunk("auth/sendCode", async (email) => {
  const response = await apiClient.post("auth/code", { email });
  return response.data;
});

export const getUserData = createAsyncThunk("auth/getUserData", async () => {
  const response = await apiClient.get(`user/profile`).then((res) => res.data);

  if (!response.data) {
    localStorage.removeItem("accessToken");
    throw new Error();
  }

  return response.data;
});

export const logoutApi = createAsyncThunk("auth/logoutApi", async () => {
  const response = await apiClient.delete("auth/session");
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
  return response;
});

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    clearAuthState: (state) => {
      state.registrationError = "";
      state.loginError = "";
    },
    clearLoginState: (state) => {
      state.loginError = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginApi.rejected, (state, action) => {
        state.errorMessage = action.error.message;
      })

      .addCase(getUserData.fulfilled, (state, action) => {
        state.isAuth = true;
        state.loadingApp = true;
        state.user = action.payload;
      })
      .addCase(getUserData.pending, (state, action) => {
        if (!action.meta.arg?.withoutLoadingApp) {
          state.isAuth = false;
          state.loadingApp = false;
        }
      })
      .addCase(getUserData.rejected, (state) => {
        state.isAuth = false;
        state.loadingApp = true;
      })

      .addCase(logoutApi.fulfilled, (state) => {
        state.isAuth = false;
        state.user = {};
        state.registerSuccess = false;
      });
  },
});

export const { clearAuthState, clearLoginState } = authSlice.actions;

export default authSlice.reducer;
